export var BlockCondition;
(function (BlockCondition) {
    BlockCondition[BlockCondition["LOADING"] = 0] = "LOADING";
    BlockCondition[BlockCondition["EMPTY"] = 1] = "EMPTY";
    BlockCondition[BlockCondition["ERROR"] = 2] = "ERROR";
    BlockCondition[BlockCondition["LOADED"] = 3] = "LOADED";
})(BlockCondition || (BlockCondition = {}));
//# sourceMappingURL=BlockCondition.js.map